export const confirmationModal = {
  wrapper: "fixed inset-0 z-70 flex items-center justify-center",
  overlay: "fixed inset-0 bg-black/30 backdrop-blur-sm",
  container: "relative bg-gray-900 w-full max-w-md flex flex-col rounded-lg shadow-xl z-80",
  header: {
    wrapper: "flex-none p-4 border-b border-gray-800 flex items-center justify-center",
    title: "text-lg font-semibold bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent"
  },
  alert: {
    wrapper: "flex items-center space-x-2 p-3 rounded-lg bg-cyan-400/10 border border-cyan-400/20",
    text: "text-sm text-gray-300"
  },
  content: {
    wrapper: "flex-1 p-6 space-y-6",
    header: "flex items-center space-x-2 mb-3",
    section: "space-y-3 bg-gray-800/50 p-4 rounded-lg",
    title: "text-sm font-medium text-gray-300",
    list: "space-y-2 text-gray-400 text-sm"
  },
  footer: {
    wrapper: "flex-none p-4 border-t border-gray-800 flex justify-end space-x-3",
    button: {
      confirm: "px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 bg-gradient-to-r from-cyan-500 to-blue-500 hover:from-cyan-400 hover:to-blue-400 text-white",
      cancel: "px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 bg-gray-700 hover:bg-gray-600 text-white"
    }
  }
} 